import { Box, Flex } from '@chakra-ui/react';
import { DataBoxesContainer } from 'src/components/atoms/DataBoxesContainer';
import { ApiForecast } from 'src/api/queries';
import { DeleteForecastButton } from '../../molecules/DeleteForecastButton';
import { ForecastMetrics } from '../ForecastMetrics';
import { ForecastChart } from '../ForecastChart';
import { ChannelContributionChart } from '../ChannelContributionChart';
import { ForecastSummary } from '../ForecastSummary';

type ForecastPanelProps = {
  forecast: ApiForecast;
  isOpen: boolean;
};

export const ForecastPanel: React.FC<ForecastPanelProps> = ({
  forecast,
  isOpen,
}) => {
  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-start">
        <ForecastMetrics forecast={forecast} />
        <DeleteForecastButton forecastId={forecast.forecastId} />
      </Flex>
      {isOpen && (
        <Box mt="20px">
          <DataBoxesContainer>
            <ForecastChart forecast={forecast} />
            {forecast.scenarios.map((_, idx) => (
              <ChannelContributionChart
                key={idx}
                forecast={forecast}
                scenarioIndex={idx}
              />
            ))}
            <ForecastSummary forecast={forecast} />
          </DataBoxesContainer>
        </Box>
      )}
    </Box>
  );
};
